var CloudCaptureController = {

    isSSl: false,
    urlCore: null,
    portNumber: 0,
    urlFull: '',
    urlImage: '',
    attemptCount: 0,
    HTTPPortNumber: [4050],
    HTTPSPortNumber: [7090],
    driversOffline: false,
    //HTTPPortNumber: [4050, 5161, 6272],
    //HTTPSPortNumber: [7090, 8191, 9292],

    versionInstalled: null,

    init: function () {

        this.isSSl = document.location.href.indexOf('https://') > -1;
        this.urlCore = CloudCaptureController.isSSl ? 'https://localhost:' : 'http://localhost:';
    },

    constructUrl: function (indexPort, callback) {

        CloudCaptureController.portNumber = CloudCaptureController.isSSl ? CloudCaptureController.HTTPSPortNumber[indexPort] : CloudCaptureController.HTTPPortNumber[indexPort];
        CloudCaptureController.urlFull = CloudCaptureController.urlCore + CloudCaptureController.portNumber;

        // Cria uma url para image adicionando se é ssl ou não
        var ssl = CloudCaptureController.isSSl ? 'ssl/' : '';
        CloudCaptureController.urlImage = CloudCaptureController.urlFull + '/CloudCapture/' + ssl;

        if (callback) callback();
    },

    hasInstalled: function (versionVal, callback, callbackError, removeFixed, globalAjax) {

        if (CloudCaptureController.portNumber == 0) {
            Loader.fixed = true;
            Loader.show();
            CloudCaptureController.constructUrl(0);
        }

        // Adiciona a quantidade de tentivas de acordo com o número de portas para se trabalhar
        var countValidate = CloudCaptureController.isSSl ? CloudCaptureController.HTTPSPortNumber.length : CloudCaptureController.HTTPPortNumber.length;

        var funcCallbackError = callbackError || function (XMLHttpRequest, textStatus, errorThrown) {

            CloudCaptureController.attemptCount++;
            if (CloudCaptureController.attemptCount < countValidate) {
                CloudCaptureController.constructUrl(CloudCaptureController.attemptCount, function () {
                    CloudCaptureController.hasInstalled(versionVal, callback, funcCallbackError);
                });
            }
            else {
                if (XMLHttpRequest && XMLHttpRequest.state().toLowerCase() == 'rejected') {
                    var message = 'Para digitalizar documentos você precisa da versão ' + GlobalValues.cloudCaptureVersion + ' do módulo de digitalização.';
                    if (typeof (downloadCtrl) != 'undefined')
                        downloadCtrl.downloadShow(message);
                    else
                        MessageController.alert("Módulo de captura não instalado", message);

                    Loader.removeFixed();
                }
            }
        };

        var data = { version: versionVal };
        CloudCaptureController.call('HasInstalled', data,
                function (result) {

                    if (result != null)
                        CloudCaptureController.versionInstalled = result.versionInstalled;

                    callback(result);
                },
                funcCallbackError,
                3000, 
                globalAjax);
    },

    hasInstalledSilent: function (versionVal, callback, callbackError, removeFixed, timeout) {

        if (CloudCaptureController.portNumber == 0) {
            Loader.fixed = true;
            Loader.show();
            CloudCaptureController.constructUrl(0);
        }

        var timeoutValue = 3000;
        if (timeout > 0)
            timeoutValue = timeout;

        // Adiciona a quantidade de tentivas de acordo com o número de portas para se trabalhar
        var countValidate = CloudCaptureController.isSSl ? CloudCaptureController.HTTPSPortNumber.length : CloudCaptureController.HTTPPortNumber.length;

        var funcCallbackError = function (XMLHttpRequest, textStatus, errorThrown) {

            CloudCaptureController.attemptCount++;
            if (CloudCaptureController.attemptCount < countValidate) {
                CloudCaptureController.constructUrl(CloudCaptureController.attemptCount, function () {
                    CloudCaptureController.hasInstalledSilent(versionVal, callback, funcCallbackError);
                });
            }
            else {
                if (XMLHttpRequest && XMLHttpRequest.state().toLowerCase() == 'rejected') {
                    if (callback) callback({ result: 'rejected' });

                    if (!removeFixed)
                        Loader.removeFixed();
                }
            }

            if (callbackError) callbackError();
        };

        var data = { version: versionVal };
        CloudCaptureController.call('HasInstalled', data,
                function (result) {
                    callback(result);

                    if (!removeFixed)
                        Loader.removeFixed();
                },
                funcCallbackError,
                timeoutValue);
    },

    showMessageDriverOffline: function () {
        MessageController.alert('TranslateWord(Attention)', 'Esta funcionalidade está desabilitada porque não foi identificado um driver de scanner instalado que seja compatível com TWAIN 2.0 ou superior.', null, '475px', '130px');
    },

    initialize: function (identifier, isNewBatch, xmlSetting, callback, callbackError) {
        CloudCaptureController.constructXmlSetting(identifier, isNewBatch, xmlSetting, 0, 0, callback, callbackError);
    },

    constructXmlSetting: function (identifier, isNewBatch, xml, index, countIndex, callback, callbackError) {
        var resultPart = '';
        var countIndex = countIndex;
        var toLength = index + 1000;
        resultPart = xml.substring(index, toLength);

        var construct = { xml: resultPart, countIndex: countIndex };
        CloudCaptureController.call('ConstructXmlSetting', construct, function () {
            if (toLength < xml.length) {
                countIndex = countIndex + 1;
                CloudCaptureController.constructXmlSetting(identifier, isNewBatch, xml, toLength, countIndex, callback, callbackError);
            }
            else {
                var batch = isNewBatch ? true : false;
                var data = { identifier: identifier, isNewBatch: batch };
                CloudCaptureController.call('Initialize', data, callback, callbackError);
            }
        }, callbackError);
    },

    chooseScannerInfo: function (scanner, callback, callbackError) {
        var data = { scannerName: scanner }

        CloudCaptureController.call('ChooseScannerInfo', data, callback, callbackError);
    },

    selectScanner: function (callback, callbackError) {

        if (CloudCaptureController.driversOffline)
            CloudCaptureController.showMessageDriverOffline();
        else
            CloudCaptureController.call('SelectScanner', null, callback, callbackError);
    },

    applySetting: function (xml, callback, callbackError) {
        var data = { xmlSetting: xml };

        CloudCaptureController.call('ApplySetting', data, callback, callbackError);
    },

    acquireImageBySteps: function (identifierVal, callback, callbackerror) {

        if (CloudCaptureController.driversOffline) {
            CloudCaptureController.showMessageDriverOffline();
            Loader.hideScan();
            return;
        }

        Loader.updateScanningMessage('Digitalizando, aguarde...');
        CloudCaptureController.call('GetIndexPreview', null, function (indexPrev) {

            var callbackStep1 = function (result) {

                if (result.CanceledUserInterface) {
                    callback(result);
                    return;
                }

                Loader.updateScanningMessage('Aplicando filtros, aguarde...');
                PreviewImageController.changeLoadMessage('Aplicando filtros, aguarde...');

                var callbackStep2 = function (result) {
                    Loader.updateScanningMessage('Reconhecendo códigos de barras, aguarde...');
                    PreviewImageController.changeLoadMessage('Reconhecendo códigos de barras, aguarde...');

                    var callbackStep3 = function (result) {

                        var callbackStepFinal = function () {
                            Loader.updateScanningMessage('Atualizando arquivos, aguarde...');
                            PreviewImageController.changeLoadMessage('Atualizando arquivos, aguarde...');

                            if (callback) callback(result);
                        };

                        if (settingsController.application.enableCover) {
                            Loader.updateScanningMessage('Organizando capas, aguarde...');
                            PreviewImageController.changeLoadMessage('Organizando capas, aguarde...');

                            var params = {
                                server: GlobalValues.ApplicationUrl,
                                appId: settingsController.application.id,
                                appCode: settingsController.application.code,
                                appAlias: settingsController.application.alias,
                                userId: GlobalValues.CurrentUserId,
                                userName: GlobalValues.CurrentUserLogin
                            };

                            CloudCaptureController.call('ReallocateBatchCoverFiles', params, callbackStepFinal, callbackerror);
                        }
                        else
                            callbackStepFinal();
                    };

                    var barData =
                        {
                            identifier: identifierVal,
                            factor: settingsController.barcodeData.factor,
                            direction: settingsController.barcodeData.direction,
                            firstStop: settingsController.barcodeData.firstStop,
                            jumpStart: settingsController.barcodeData.jumpStart,
                            jumpEnd: settingsController.barcodeData.jumpEnd,
                            breakByFileQuantity: settingsController.application.breakBy == 'file' ? settingsController.application.breakByFileQuantity : 0,
                            coverEnable: settingsController.application.enableCover
                        };
                    CloudCaptureController.call('JustReadBarcode', barData, callbackStep3, callbackerror);
                };

                var applyData = { identifier: identifierVal };
                CloudCaptureController.call('JustApplyFilters', applyData, callbackStep2, callbackerror);
            };

            var acquireData =
                {
                    identifier: identifierVal,
                    factor: settingsController.barcodeData.factor,
                    direction: settingsController.barcodeData.direction,
                    firstStop: settingsController.barcodeData.firstStop,
                    jumpStart: settingsController.barcodeData.jumpStart,
                    jumpEnd: settingsController.barcodeData.jumpEnd,
                    quantityAcquire: settingsController.limitInputFiles.quantityAcquire,
                    breakByFileQuantity: settingsController.application.breakBy == 'file' ? settingsController.application.breakByFileQuantity : 0,
                    coverEnable: settingsController.application.enableCover
                };
            CloudCaptureController.call('JustAcquireImage', acquireData, callbackStep1, callbackerror);
            PreviewImageController.onShowPreviewImages(indexPrev, 'Digitalizando, aguarde...', 'scan');
        });
    },

    addPage: function (identifierVal, beforeFileIdVal, factorVal, directionVal, firstStopVal, jumpStartVal, jumpEndVal, callback, callbackError) {

        if (CloudCaptureController.driversOffline) {
            CloudCaptureController.showMessageDriverOffline();
            Loader.hideScan();
            return;
        }

        var params = {
            identifier: identifierVal,
            beforeFileId: beforeFileIdVal,
            factor: factorVal,
            direction: directionVal,
            firstStop: firstStopVal,
            jumpStart: jumpStartVal,
            jumpEnd: jumpEndVal,
            breakByFileQuantity: settingsController.application.breakBy == 'file' ? settingsController.application.breakByFileQuantity : 0,
            coverEnable: settingsController.application.enableCover
        };
        CloudCaptureController.call('AddPage', params, callback, callbackError);
    },

    replaceFile: function (id, factorVal, directionVal, firstStopVal, jumpStartVal, jumpEndVal, callback, callbackError) {

        if (CloudCaptureController.driversOffline) {
            CloudCaptureController.showMessageDriverOffline();
            Loader.hideScan();
            return;
        }

        var params = {
            fileId: id,
            factor: factorVal,
            direction: directionVal,
            firstStop: firstStopVal,
            jumpStart: jumpStartVal,
            jumpEnd: jumpEndVal,
            breakByFileQuantity: settingsController.application.breakBy == 'file' ? settingsController.application.breakByFileQuantity : 0
        };
        CloudCaptureController.call('ReplaceFile', params, callback, callbackError);
    },

    removeFile: function (id, callback, callbackError) {
        var params = { fileId: id };
        CloudCaptureController.call('RemoveFile', params, callback, callbackError);
    },

    removeMultipleFiles: function (identifierVal, filesId, callback, callbackError) {
        var params = { identifier: identifierVal, filesId: filesId };
        CloudCaptureController.call('RemoveMultipleFiles', params, callback, callbackError);
    },

    renameFile: function (id, name, callback, callbackError) {
        var params = { fileId: id, fileName: name };
        CloudCaptureController.call('RenameFile', params, callback, callbackError);
    },

    moveUpFile: function (identifierVal, id, callback, callbackError) {
        var params = { identifier: identifierVal, fileId: id };
        CloudCaptureController.call('MoveUpFile', params, callback, callbackError);
    },

    moveDownFile: function (identifierVal, id, callback, callbackError) {
        var params = { identifier: identifierVal, fileId: id };
        CloudCaptureController.call('MoveDownFile', params, callback, callbackError);
    },

    moveUpBetweenkDocument: function (identifierVal, id, barcode, callback, callbackError) {
        var params = { identifier: identifierVal, fileId: id, breakBarcode: barcode };
        CloudCaptureController.call('MoveUpBetweenkDocument', params, callback, callbackError);
    },

    moveDownBetweenkDocument: function (identifierVal, id, barcode, callback, callbackError) {
        var params = { identifier: identifierVal, fileId: id, breakBarcode: barcode };
        CloudCaptureController.call('MoveDownBetweenkDocument', params, callback, callbackError);
    },

    addPageWithoutFilters: function (scannerCapabilitiesJSon, saveFilesJSON, callback, callbackError) {

        if (CloudCaptureController.driversOffline) {
            CloudCaptureController.showMessageDriverOffline();
            return;
        }

        var data = {
            identifier: 'LOTIDCONFIGACQUIRE2016',
            scannerCapabilitiesJSon: scannerCapabilitiesJSon,
            saveFilesJSON: saveFilesJSON
        };

        CloudCaptureController.call('AddPageWithoutFilters', data, callback, callbackError);
    },

    applyFilters: function (fileId, callback, callbackError) {
        var numberRdn = (Math.random() + '').replace('.', '');

        return CloudCaptureController.urlImage + 'ApplyFilters/' + fileId + '/' + Math.random();
    },

    getImageUrl: function (fileId, callback, callbackError) {
        var numberRdn = (Math.random() + '').replace('.', '');
        return CloudCaptureController.urlImage + 'ViewImage/' + fileId + '/0/' + Math.random();
    },

    getImageUrlPage: function (fileId, page) {
        var numberRdn = (Math.random() + '').replace('.', '');
        return CloudCaptureController.urlImage + 'ViewImage/' + fileId + '/' + page + '/' + Math.random();
    },

    rotateRight: function (fileId, angle, page) {
        var numberRdn = (Math.random() + '').replace('.', '');
        return CloudCaptureController.urlImage + 'RotateImage/' + fileId + '/' + page + '/' + angle + '/' + Math.random();
    },

    rotateLeft: function (fileId, angle, page) {
        var numberRdn = (Math.random() + '').replace('.', '');
        return CloudCaptureController.urlImage + 'RotateImage/' + fileId + '/' + page + '/' + angle + '/' + Math.random();
    },

    getThumbnailUrl: function (fileId) {
        var numberRdn = (Math.random() + '').replace('.', '');
        return CloudCaptureController.urlImage + 'ViewThumbnail/' + fileId + '/' + Math.random();
    },

    reloadFilters: function (filtersJSON, filtersSettingsJSON, callback, callbackError) {
        var data = { filtersJSON: filtersJSON, filtersSettingsJSON: filtersSettingsJSON };

        CloudCaptureController.call('ReloadFilters', data, callback, callbackError);
    },

    importFileByStep: function (identifierVal, callback, callbackError) {
        Loader.updateScanningMessage('Importando aquivos, aguarde...');

        CloudCaptureController.call('GetIndexPreview', null, function (indexPrev) {

            var callbackStep1 = function (result) {
                Loader.updateScanningMessage('Aplicando filtros, aguarde...');
                PreviewImageController.changeLoadMessage('Aplicando filtros, aguarde...');

                var callbackStep2 = function (result) {
                    Loader.updateScanningMessage('Reconhecendo códigos de barras, aguarde...');
                    PreviewImageController.changeLoadMessage('Reconhecendo códigos de barras, aguarde...');

                    var callbackStep3 = function (result) {
                        var callbackStepFinal = function () {
                            Loader.updateScanningMessage('Atualizando arquivos, aguarde...');
                            PreviewImageController.changeLoadMessage('Atualizando arquivos, aguarde...');

                            if (callback) callback(result);
                        };

                        if (settingsController.application.enableCover) {
                            Loader.updateScanningMessage('Organizando capas, aguarde...');
                            PreviewImageController.changeLoadMessage('Organizando capas, aguarde...');

                            var params = {
                                server: GlobalValues.ApplicationUrl,
                                appId: settingsController.application.id,
                                appCode: settingsController.application.code,
                                appAlias: settingsController.application.alias,
                                userId: GlobalValues.CurrentUserId,
                                userName: GlobalValues.CurrentUserLogin
                            };

                            CloudCaptureController.call('ReallocateBatchCoverFiles', params, callbackStepFinal, callbackError);
                        }
                        else
                            callbackStepFinal();
                    };

                    var barData =
                        {
                            identifier: identifierVal,
                            factor: settingsController.barcodeData.factor,
                            direction: settingsController.barcodeData.direction,
                            firstStop: settingsController.barcodeData.firstStop,
                            jumpStart: settingsController.barcodeData.jumpStart,
                            jumpEnd: settingsController.barcodeData.jumpEnd,
                            breakByFileQuantity: settingsController.application.breakBy == 'file' ? settingsController.application.breakByFileQuantity : 0,
                            coverEnable: settingsController.application.enableCover
                        };
                    CloudCaptureController.call('JustReadBarcode', barData, callbackStep3, callbackError);
                };

                var applyData = { identifier: identifierVal };
                CloudCaptureController.call('JustApplyFilters', applyData, callbackStep2, callbackError);
            };

            var importData =
                {
                    identifier: identifierVal,
                    factor: settingsController.barcodeData.factor,
                    direction: settingsController.barcodeData.direction,
                    firstStop: settingsController.barcodeData.firstStop,
                    jumpStart: settingsController.barcodeData.jumpStart,
                    jumpEnd: settingsController.barcodeData.jumpEnd,
                    quantityImport: settingsController.limitInputFiles.quantityImport,
                    breakByFileQuantity: settingsController.application.breakBy == 'file' ? settingsController.application.breakByFileQuantity : 0,
                    coverEnable: settingsController.application.enableCover
                };
            CloudCaptureController.call('JustImportFile', importData, callbackStep1, callbackError);
            PreviewImageController.onShowPreviewImages(indexPrev, 'Importando aquivos, aguarde...', 'import');
        });
    },

    importFileWithoutSettings: function (callback, callbackError) {
        var data = { identifier: 'LOTIDCONFIGACQUIRE2016' };
        CloudCaptureController.call('ImportFileWithoutSettings', data, callback, callbackError);
    },

    endDocument: function (params, callback, callbackError) {
        // AjaxHelper.Json fazer json do parametro
        var jsonParam = JSON.parse(AjaxHelper.toJSON(params));
        CloudCaptureController.call('EndDocument', jsonParam, callback, callbackError);
    },

    endBatch: function (params, callback, callbackError) {
        // AjaxHelper.Json fazer json do parametro
        var jsonParam = JSON.parse(AjaxHelper.toJSON(params));
        CloudCaptureController.call('EndDocumentBach', jsonParam, callback, callbackError);
    },

    getDriverScanner: function (callback, callbackError) {

        if (CloudCaptureController.driversOffline) {
            CloudCaptureController.showMessageDriverOffline();
            return;
        }

        CloudCaptureController.call('GetDriverScanners', null, callback, callbackError);
    },

    getScannerInfo: function (onlySupportedVal, scanner, callback, callbackError) {

        if (CloudCaptureController.driversOffline) {
            CloudCaptureController.showMessageDriverOffline();
            return;
        }

        var data = { onlySupported: onlySupportedVal, scanner: scanner };
        CloudCaptureController.call('GetScannerInfo', data, callback, callbackError);
    },

    getSystemInfo: function (callback, callbackError) {
        CloudCaptureController.call('GetSystemInfo', null, callback, callbackError);
    },

    verifyUploadQueue: function (callback, callbackError) {
        CloudCaptureController.call('VerifyUploadQueue', null, callback, callbackError);
    },

    getUploadQueue: function (callback, callbackError) {
        CloudCaptureController.call('GetUploadQueue', null, callback, callbackError);
    },

    getUploadHistoryDate: function (callback, callbackError) {
        CloudCaptureController.call('GetUploadHistoryDate', null, callback, callbackError);
    },

    getUploadHistory: function (logPath, callback, callbackError) {
        var data = { path: encodeURI(logPath) };
        CloudCaptureController.call('GetUploadHistory', data, callback, callbackError);
    },

    deleteUploadFile: function (params, byPool, callback, callbackError) {

        var methodName = byPool ? 'DeleteUploadFilePool' : 'DeleteUploadFile';
        var jsonParam = JSON.parse(AjaxHelper.toJSON(params));

        CloudCaptureController.call(methodName, jsonParam, callback, callbackError);
    },

    retransmitUpload: function (params, callback, callbackError) {
        var jsonParam = JSON.parse(AjaxHelper.toJSON(params));
        CloudCaptureController.call('RetransmitUpload', jsonParam, callback, callbackError);
    },

    getCroppedImageUrl: function (fileId, x, y, h, w, currentWidth, currentPage) {
        var numberRdn = (Math.random() + '').replace('.', '');
        return CloudCaptureController.urlImage + 'ViewCroppedImage/' + fileId + '/' + x + '/' + y + '/' + h + '/' + w + '/' + currentWidth + '/' + currentPage + '/' + numberRdn;
    },

    addNewCroppedImage: function (identifierVal, fileId, callback, callbackError) {
        var params = { identifier: identifierVal, fileId: fileId };

        CloudCaptureController.call('AddNewCroppedImage', params, callback, callbackError);
    },

    replaceCroppedImage: function (fileId, callback, callbackError) {
        var params = { fileId: fileId };

        CloudCaptureController.call('ReplaceCroppedImage', params, callback, callbackError);
    },

    deleteDocument: function (documentId, callback, callbackError) {
        var params = { documentId: documentId };

        CloudCaptureController.call('DeleteDocument', params, callback, callbackError);
    },

    DeleteBatch: function (params, callback, callbackError) {
        var jsonParam = JSON.parse(AjaxHelper.toJSON(params));
        CloudCaptureController.call('DeleteBatch', jsonParam, callback, callbackError);
    },

    DeleteFileList: function (identifierVal, barcode, fileId, callback, callbackError) {
        // AjaxHelper.Json fazer json do parametro
        var params = { identifier: identifierVal, barcode: barcode, fileId: fileId };
        CloudCaptureController.call('DeleteFileList', params, callback, callbackError);
    },

    breakBatch: function (sourceIdentifierVal, newIdentifierVal, indexFileVal, callback, callbackError) {
        var params =
            {
                sourceIdentifier: sourceIdentifierVal,
                newIdentifier: newIdentifierVal,
                indexFile: indexFileVal,
                server: GlobalValues.ApplicationUrl,
                appId: settingsController.application.id,
                appCode: settingsController.application.code,
                appAlias: settingsController.application.alias,
                userId: GlobalValues.CurrentUserId,
                userName: GlobalValues.CurrentUserLogin,
                documentLimits: settingsController.application.documentQuantity == null || settingsController.application.documentQuantity == '' ? 0 : settingsController.application.documentQuantity,
                fileKindLimit: settingsController.application.filesQuantityByDocument ? 'document' : 'batch',
                filesLimit: settingsController.application.filesQuantity == null || settingsController.application.filesQuantity == '' ? 0 : settingsController.application.filesQuantity
            };
        CloudCaptureController.call('BreakBatch', params, callback, callbackError);
    },

    replaceIdentifierDocument: function (sourceIdentifierVal, newIdentifierVal, callback, callbackError) {
        var params = { sourceIdentifier: sourceIdentifierVal, newIdentifier: newIdentifierVal };
        CloudCaptureController.call('ReplaceIdentifierDocument', params, callback, callbackError);
    },

    editBatch: function (sourceIdentifierVal, newIdentifierVal, documentLimitVal, fileKindLimitVal, fileLimitVal, callback, callbackError) {
        var params =
            {
                sourceIdentifier: sourceIdentifierVal,
                newIdentifier: newIdentifierVal,
                documentLimit: documentLimitVal,
                fileKindLimit: fileKindLimitVal,
                fileLimit: fileLimitVal
            };
        CloudCaptureController.call('EditBatch', params, callback, callbackError);
    },

    loadBatchFiles: function (identifierVal, callback, callbackError) {
        var params = { identifier: identifierVal };
        CloudCaptureController.call('LoadBatchFiles', params, callback, callbackError);
    },

    breackDocument: function (barcode, file, callback, callbackError) {
        var params = { breakBarcode: barcode, fileId: file };
        CloudCaptureController.call('BreackDocument', params, callback, callbackError);
    },

    getPreIndexPrint: function (callback, callbackError) {
        CloudCaptureController.call('SelectPrint', null, callback, callbackError);
    },

    sendPreIndexPrint: function (pdfUrl, callback, callbackError) {
        var params = { url: pdfUrl };
        CloudCaptureController.call('SendToPrint', params, callback, callbackError);
    },

    checkNotEndeds: function (callback, callbackError) {

        var params = {
            appCode: settingsController.application.code,
            server: GlobalValues.ApplicationUrl,
            type: settingsController.scanningDocument ? 'document' : 'batch'
        };

        CloudCaptureController.call('CheckNotEndeds', params, callback, callbackError);
    },

    checkBatchExists: function (identifier, callback, callbackError) {
        var params = { batchName: identifier };

        CloudCaptureController.call('CheckBatchExists', params, callback, callbackError);
    },

    createXmlBackup: function (identifier, type, server, appId, appCode, appAlias, userId, userName, documentLimits,
        fileKindLimit, filesLimit, callback, callbackError) {

        var params = {
            identifier: identifier,
            type: type,
            server: server,
            appId: appId,
            appCode: appCode,
            appAlias: appAlias,
            userId: userId,
            userName: userName,
            documentLimits: documentLimits,
            fileKindLimit: fileKindLimit,
            filesLimit: filesLimit
        };

        CloudCaptureController.call('CreateXmlBackup', params, callback, callbackError);
    },

    discardIdentifiers: function (identifiers, callback, callbackError) {
        var params = {
            identifiers: AjaxHelper.toCollectionJSON(identifiers, 1)
        };

        CloudCaptureController.call('RemoveByIdentifiers', params, callback, callbackError);
    },

    restoreIdentifier: function (identifier, callback, callbackError) {
        var params = {
            identifiers: AjaxHelper.toCollectionJSON(identifier, 1),
            breakByFileQuantity: settingsController.application.breakBy == 'file' ? settingsController.application.breakByFileQuantity : 0,
        };

        CloudCaptureController.call('RestoreByIdentifiers', params, callback, callbackError);
    },

    readBarcodeAfterRestore: function (identifierVal, callback, callbackError) {
        var callbackStep3 = function (result) {
            Loader.updateScanningMessage('Atualizando arquivos, aguarde...');

            if (callback) callback(result, true);
        };

        var barData =
            {
                identifier: identifierVal,
                factor: settingsController.barcodeData.factor,
                direction: settingsController.barcodeData.direction,
                firstStop: settingsController.barcodeData.firstStop,
                jumpStart: settingsController.barcodeData.jumpStart,
                jumpEnd: settingsController.barcodeData.jumpEnd,
                breakByFileQuantity: settingsController.application.breakBy == 'file' ? settingsController.application.breakByFileQuantity : 0,
                coverEnable: settingsController.application.enableCover
            };
        CloudCaptureController.call('JustReadBarcode', barData, callbackStep3, callbackError);
    },

    getBatchesToPreIndex: function (identifiers, callback, callbackError) {
        var params = { identifierList: identifiers };
        CloudCaptureController.call('GetBatchesToPreIndex', params, callback, callbackError);
    },

    getCoversToValidate: function (identifiers, callback, callbackError) {
        var params = { identifierList: identifiers };
        CloudCaptureController.call('GetCoversToValidate', params, callback, callbackError);
    },

    lockIdentifier: function (params, callback, callbackError) {
        var jsonParam = JSON.parse(AjaxHelper.toJSON(params));
        CloudCaptureController.call('LockIdentifier', jsonParam, callback, callbackError);
    },

    configScannerInfo: function (scannerName, callback, callbackError) {

        if (CloudCaptureController.driversOffline) {
            CloudCaptureController.showMessageDriverOffline();
            return;
        }

        var params = { scanner: scannerName };
        CloudCaptureController.call('ConfigScannerInfo', params, callback, callbackError);
    },

    saveSnapShot: function (callback, callbackError) {

        if (CloudCaptureController.driversOffline) {
            CloudCaptureController.showMessageDriverOffline();
            return;
        }

        CloudCaptureController.call('SaveSnapShot', null, callback, callbackError);
    },

    loadSnapShot: function (scannerName, callback, callbackError) {

        if (CloudCaptureController.driversOffline) {
            CloudCaptureController.showMessageDriverOffline();
            return;
        }

        var params = { scanner: scannerName };

        CloudCaptureController.call('LoadSnapShot', params, callback, callbackError);
    },

    constructureSnapShot: function (xmlConfiguration, callback, callbackError) {
        var params = { xml: xmlConfiguration };

        CloudCaptureController.call('ConstructureSnapShot', params, callback, callbackError);
    },

    constructureDictionarySnapShot: function (id, callback, callbackError) {
        var params = { snapId: id };

        CloudCaptureController.call('ConstructureDictionarySnapShot', params, callback, callbackError);
    },

    editOnDesktop: function (indexId, fileId, applicationId, applicationCode, isVersion, userToken, callback, callbackError) {
        var params = {
            urlServer: GlobalValues.ApplicationUrl,
            indexId: indexId,
            fileId: fileId,
            applicationId: applicationId,
            applicationCode: applicationCode,
            isVersion: isVersion,
            userToken: userToken
        };

        CloudCaptureController.call('DownloadToEdit', params, callback, callbackError);
    },

    editOnDesktop: function (indexId, fileId, applicationId, applicationCode, isVersion, userToken, callback, callbackError) {
        var params = {
            urlServer: GlobalValues.ApplicationUrl,
            indexId: indexId,
            fileId: fileId,
            applicationId: applicationId,
            applicationCode: applicationCode,
            isVersion: isVersion,
            userToken: userToken,
            action: 'editword'
        };

        CloudCaptureController.call('DownloadToEdit', params, callback, callbackError);
    },

    signPdf: function (indexId, fileId, applicationId, applicationCode, isVersion, userToken, callback, callbackError) {
        var params = {
            urlServer: GlobalValues.ApplicationUrl,
            indexId: indexId,
            fileId: fileId,
            applicationId: applicationId,
            applicationCode: applicationCode,
            isVersion: isVersion,
            userToken: userToken,
            action: 'signpdf'
        };

        CloudCaptureController.call('DownloadToEdit', params, callback, callbackError);
    },

    myDocumentsSignPdf: function (indexId, fileId, applicationId, applicationCode, isVersion, userToken, callback, callbackError) {
        var params = {
            urlServer: GlobalValues.ApplicationUrl,
            indexId: indexId,
            fileId: fileId,
            applicationId: applicationId,
            applicationCode: applicationCode,
            isVersion: isVersion,
            userToken: userToken,
            action: 'mydocssignpdf'
        };

        CloudCaptureController.call('DownloadToEdit', params, callback, callbackError);
    },

    BPMSign: function (bpmBaseURL, token, codFlowExecute, codFlowExecuteTask, filePaths, callback, callbackError) {
        var params = {
            baseURL: bpmBaseURL,
            token: token,
            CodFlowExecute: codFlowExecute,
            CodFlowExecuteTask: codFlowExecuteTask,
            FilePaths: filePaths
        };

        CloudCaptureController.call('BPMSignV4', params, callback, callbackError);
    },

    IsRefreshFiles: function (callback, callbackError) {
        CloudCaptureController.call('IsRefreshFiles', null, callback, callbackError);
    },

    ValidateOfficeRequirements: function (officeExtension, callback, callbackError) {
        var params = {
            officeExtension: officeExtension
        };

        CloudCaptureController.call('ValidateOfficeRequirements', params, callback, callbackError);
    },

    IsBeingEdited: function (fileAlias, callback, callbackError) {
        var params = {
            fileAlias: fileAlias
        };

        CloudCaptureController.call('IsBeingEdited', params, callback, callbackError);
    },

    call: function (method, params, callback, callbackError, timeout, globalAjax) {
        globalAjax = globalAjax !== false;

        var ssl = CloudCaptureController.isSSl ? 'ssl/' : '';
        var timeoutValue = null;

        if (timeout)
            timeoutValue = timeout;

        $.ajax({
            url: CloudCaptureController.urlFull + '/CloudCapture/' + ssl + method,
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'jsonp',
            scriptCharset: 'UTF-8',
            cache: false,
            crossDomain: true,
            data: params,
            timeout: timeoutValue,
            global: globalAjax,
            success: function (res) {

                res = jQuery.parseJSON(res);
                if (res && res.error) {
                    MessageController.showError(res.error, res.message);
                }
                else if (res && res.locked) {
                    MessageController.alert('TranslateWord(Attention)', 'O lote foi submetido ao processo de encerramento e não poderá mais ser modificado.',
                        function () {
                            document.location.href = document.location.href;
                        }, '460px', '120px');
                }
                else {
                    if (callback) callback(res);
                }
            },
            error: callbackError ? callbackError : function (XMLHttpRequest, textStatus, exception) {

                var message;
                var statusErrorMap = {
                    '400': "Server understood the request, but request content was invalid.",
                    '401': "Unauthorized access.",
                    '403': "Forbidden resource can't be accessed.",
                    '500': "Internal server error.",
                    '503': "Service unavailable."
                };

                if (XMLHttpRequest.status == '200')
                    return;

                if (XMLHttpRequest.status) {
                    message = statusErrorMap[XMLHttpRequest.status];
                    if (!message) {
                        message = "Unknown Error \n.";
                    }
                } else if (exception == 'parsererror') {
                    message = "Error.\nParsing JSON Request failed.";
                } else if (exception == 'timeout') {
                    message = "Ocorreu um tempo de espera maior do que o devido, por favor repita a operação.";
                } else if (exception == 'abort') {
                    message = "Request was aborted by the server";
                } else {
                    message = "Unknown Error \n.";
                }

                if (message != '')
                    MessageController.alert('TranslateWord(Attention)', message);
            }
        });
    }
};

$(document).ready(function () {
    CloudCaptureController.init();
});
